import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const CollectionFunctionMissingTemplateDialogBody = ({ name }: { name: string }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('collectionFunction.grid.missingTemplate.message.line1')}
      <br />
      {t('collectionFunction.grid.missingTemplate.message.line2', { name })}
    </Fragment>
  );
};

export default CollectionFunctionMissingTemplateDialogBody;
